import {PunchInfo} from "@/entity/PunchInfo";
import {Base} from "@/dto/Base";
import {CompanyPoint} from "@/entity/CompanyPoint";

export class PunchInfoDto {
    public static url = '/api/punch'

    public static  async queryPunchInfoByUserNameAndCompanyId(a: PunchInfo): Promise<CompanyPoint>{
        const  response = await Base.postWithToken(this.url + '/queryPunchInfoByUserNameAndCompanyId',a) as  any
        const  companyPoint = response.data as  CompanyPoint
        return  companyPoint
    }
    public static async insertPunchInfoByReq(a: PunchInfo): Promise<PunchInfo>{
        const  response = await Base.postWithToken(this.url + '/insertPunchInfoByReq' ,a)
        return  response as PunchInfo
    }
    public static async queryPunchInfoRecordByUserNameAndCompanyId(a: PunchInfo): Promise<PunchInfo>{
        const  response = await  Base.postWithToken(this.url + '/queryPunchInfoRecordByUserNameAndCompanyId',a) as  any
        const punchInfoRecord = response.data.workPunchTimeList
        return  punchInfoRecord
    }
}